// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FaaDpTe5mksJJE7ECwOA {
  display: flex;
  flex-direction: column;
  padding-bottom: 16px;
}

.LMA_beGStJi8TYY4lEqc {
  text-align: center;
  font-size: 32px;
  font-style: normal;
  font-weight: 510;
  line-height: 32px; /* 100% */
  letter-spacing: -0.264px;
  color: rgb(var(--placeholder-primary));
  margin-bottom: 24px;
  }

.Gx9Oz07RKVtxlwECMYKE {
  font-size: 16px;
  font-style: normal;
  font-weight: 510;
  line-height: 20px;
  letter-spacing: -0.5px;
  color: rgb(var(--placeholder-primary));
}

.J4RpgaP4b97Tz0Cz_kys {
  margin-top: 12px;
}
.YrP9KNAN36cwbjyi_Nbs {
  width: 100%;
  position: relative;
  margin-top: 12px;
}

.Phrq8HJTCdXqPMIDWbob {
  padding: 16px 16px 16px 52px;
  border: none;
  outline: none;
  background: rgba(var(--tertiary-bg), 0.30);
  backdrop-filter: blur(40px);
  -webkit-backdrop-filter: blur(40px); 
  border-radius: 16px;
  width: 100%;

  color: rgb(var(--placeholder-primary));
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: -0.154px;
}

.Phrq8HJTCdXqPMIDWbob::placeholder {
  color: rgb(var(--placeholder-secondary))
}

.PvdEfz_IkxfjcKJ7IvHG {
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  width: 24px;
  height: 24px;
}

.WuI6NYGgeec8TbrTlmbR {
  padding: 16px;
  border-radius: 24px;
  border: 1px solid rgba(var(--border), 0.20);
  background: rgba(var(--secondary-bg), 0.40);
  backdrop-filter: blur(40px);
  -webkit-backdrop-filter: blur(40px); 
  display: flex;
  flex-direction: column;
  max-width: 100%;
}
.o7qaQi4nXxpneoZt368K {
  display: flex;
  gap: 6px;
  margin-bottom: 12px;
  max-width: 100%;
}

.tZ8ZL21FcsmREMVeDChg {
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 125% */
  letter-spacing: -0.5px;
  color: rgb(var(--placeholder-secondary));
}

._ZCMt9FvSQneDFAgXSUv {
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 125% */
  letter-spacing: -0.5px;
  color: rgb(var(--placeholder-primary));

  max-width: calc(100% - 65px);
  text-wrap: nowrap;
  overflow: hidden;
}

.qgvUYyN_ZPS0NYXhOYDe {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  gap: 8px;
  align-items: center;
}

.TXZwhVRSQCR5CuHZW9p_ {
  background: transparent;
  border: none;
  width: 100%;
  text-align: right;
  color: rgb(var(--placeholder-primary));
  font-size: 32px;
  font-style: normal;
  font-weight: 510;
  line-height: 32px; /* 100% */
  letter-spacing: -0.5px;
  text-align: left;
  flex: 1;
  padding: 0;
}

.y2yMtNnJUrOy3aTh0MWm {
  height: 28px;
  font-size: 28px;
  font-style: normal;
  font-weight: 510;
  line-height: 28px; /* 100% */
  letter-spacing: -0.5px;
  color: rgb(var(--placeholder-secondary));
  flex: 1;
  width: fit-content;
  text-wrap: nowrap;
}

.q5GLCQQhDH2YmlWWwQtV {
  color: rgb(var(--accent-error));
}

.ukre9_ULcaF8pICwnZxm {
  width: 100%;
  height: 1px;
  background: rgb(var(--tertiary-bg-dark));
  margin-top: 16px;
  margin-bottom: 16px;
}

.VkkV76HiToKyp7lJncIf {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.lRWDuE5V7GCvx7hH5b3i {
  border-radius: 28px;
  background: rgba(var(--tertiary-bg), 0.30);
  backdrop-filter: blur(29px);
  -webkit-backdrop-filter: blur(29px); 
  padding: 8px 12px;
}

.vcW9ca6UfbR5UZhknWs4 {
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: -0.07px;
  color: rgb(var(--placeholder-primary));
}

.HQnxi5rCwT0Mw7VJZaBn {
  margin: auto 0 10px 0;
  width: 100%;
  font-size: 17px;
  font-weight: 540;
}

.HQnxi5rCwT0Mw7VJZaBn:disabled {
  opacity: 1;
  color: #000000de;
  background: rgba(116, 116, 128, 0.20) !important;
}

.muX61iFcxY9t68oCq6fm {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  font-size: 17px;
  font-weight: 540;
  color: #FF3B30;
}`, "",{"version":3,"sources":["webpack://./src/pages/main/buy-modal/enter-amount/enter-amount.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;EAC5B,wBAAwB;EACxB,sCAAsC;EACtC,mBAAmB;EACnB;;AAEF;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,YAAY;EACZ,aAAa;EACb,0CAA0C;EAC1C,2BAA2B;EAC3B,mCAAmC;EACnC,mBAAmB;EACnB,WAAW;;EAEX,sCAAsC;EACtC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE;AACF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2CAA2C;EAC3C,2CAA2C;EAC3C,2BAA2B;EAC3B,mCAAmC;EACnC,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;AACA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;EAC5B,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;EAC5B,sBAAsB;EACtB,sCAAsC;;EAEtC,4BAA4B;EAC5B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,sCAAsC;EACtC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;EAC5B,sBAAsB;EACtB,gBAAgB;EAChB,OAAO;EACP,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;EAC5B,sBAAsB;EACtB,wCAAwC;EACxC,OAAO;EACP,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,WAAW;EACX,wCAAwC;EACxC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,2BAA2B;EAC3B,mCAAmC;EACnC,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,sCAAsC;AACxC;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  padding-bottom: 16px;\n}\n\n.modalTitle {\n  text-align: center;\n  font-size: 32px;\n  font-style: normal;\n  font-weight: 510;\n  line-height: 32px; /* 100% */\n  letter-spacing: -0.264px;\n  color: rgb(var(--placeholder-primary));\n  margin-bottom: 24px;\n  }\n\n.formText {\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 510;\n  line-height: 20px;\n  letter-spacing: -0.5px;\n  color: rgb(var(--placeholder-primary));\n}\n\n.cardContainer {\n  margin-top: 12px;\n}\n.cardInputWrapper {\n  width: 100%;\n  position: relative;\n  margin-top: 12px;\n}\n\n.cardInput {\n  padding: 16px 16px 16px 52px;\n  border: none;\n  outline: none;\n  background: rgba(var(--tertiary-bg), 0.30);\n  backdrop-filter: blur(40px);\n  -webkit-backdrop-filter: blur(40px); \n  border-radius: 16px;\n  width: 100%;\n\n  color: rgb(var(--placeholder-primary));\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px;\n  letter-spacing: -0.154px;\n}\n\n.cardInput::placeholder {\n  color: rgb(var(--placeholder-secondary))\n}\n\n.cardIconWrapper {\n  position: absolute;\n  left: 16px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 24px;\n  height: 24px;\n}\n\n.amountContainer {\n  padding: 16px;\n  border-radius: 24px;\n  border: 1px solid rgba(var(--border), 0.20);\n  background: rgba(var(--secondary-bg), 0.40);\n  backdrop-filter: blur(40px);\n  -webkit-backdrop-filter: blur(40px); \n  display: flex;\n  flex-direction: column;\n  max-width: 100%;\n}\n.usdContainer {\n  display: flex;\n  gap: 6px;\n  margin-bottom: 12px;\n  max-width: 100%;\n}\n\n.youPay {\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px; /* 125% */\n  letter-spacing: -0.5px;\n  color: rgb(var(--placeholder-secondary));\n}\n\n.usdAmount {\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px; /* 125% */\n  letter-spacing: -0.5px;\n  color: rgb(var(--placeholder-primary));\n\n  max-width: calc(100% - 65px);\n  text-wrap: nowrap;\n  overflow: hidden;\n}\n\n.amountInner {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  gap: 8px;\n  align-items: center;\n}\n\n.amountInput {\n  background: transparent;\n  border: none;\n  width: 100%;\n  text-align: right;\n  color: rgb(var(--placeholder-primary));\n  font-size: 32px;\n  font-style: normal;\n  font-weight: 510;\n  line-height: 32px; /* 100% */\n  letter-spacing: -0.5px;\n  text-align: left;\n  flex: 1;\n  padding: 0;\n}\n\n.token {\n  height: 28px;\n  font-size: 28px;\n  font-style: normal;\n  font-weight: 510;\n  line-height: 28px; /* 100% */\n  letter-spacing: -0.5px;\n  color: rgb(var(--placeholder-secondary));\n  flex: 1;\n  width: fit-content;\n  text-wrap: nowrap;\n}\n\n.amountInputError {\n  color: rgb(var(--accent-error));\n}\n\n.line {\n  width: 100%;\n  height: 1px;\n  background: rgb(var(--tertiary-bg-dark));\n  margin-top: 16px;\n  margin-bottom: 16px;\n}\n\n.options {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n\n.option {\n  border-radius: 28px;\n  background: rgba(var(--tertiary-bg), 0.30);\n  backdrop-filter: blur(29px);\n  -webkit-backdrop-filter: blur(29px); \n  padding: 8px 12px;\n}\n\n.optionText {\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px;\n  letter-spacing: -0.07px;\n  color: rgb(var(--placeholder-primary));\n}\n\n.btn {\n  margin: auto 0 10px 0;\n  width: 100%;\n  font-size: 17px;\n  font-weight: 540;\n}\n\n.btn:disabled {\n  opacity: 1;\n  color: #000000de;\n  background: rgba(116, 116, 128, 0.20) !important;\n}\n\n.alert {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 5px;\n  font-size: 17px;\n  font-weight: 540;\n  color: #FF3B30;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `FaaDpTe5mksJJE7ECwOA`,
	"modalTitle": `LMA_beGStJi8TYY4lEqc`,
	"formText": `Gx9Oz07RKVtxlwECMYKE`,
	"cardContainer": `J4RpgaP4b97Tz0Cz_kys`,
	"cardInputWrapper": `YrP9KNAN36cwbjyi_Nbs`,
	"cardInput": `Phrq8HJTCdXqPMIDWbob`,
	"cardIconWrapper": `PvdEfz_IkxfjcKJ7IvHG`,
	"amountContainer": `WuI6NYGgeec8TbrTlmbR`,
	"usdContainer": `o7qaQi4nXxpneoZt368K`,
	"youPay": `tZ8ZL21FcsmREMVeDChg`,
	"usdAmount": `_ZCMt9FvSQneDFAgXSUv`,
	"amountInner": `qgvUYyN_ZPS0NYXhOYDe`,
	"amountInput": `TXZwhVRSQCR5CuHZW9p_`,
	"token": `y2yMtNnJUrOy3aTh0MWm`,
	"amountInputError": `q5GLCQQhDH2YmlWWwQtV`,
	"line": `ukre9_ULcaF8pICwnZxm`,
	"options": `VkkV76HiToKyp7lJncIf`,
	"option": `lRWDuE5V7GCvx7hH5b3i`,
	"optionText": `vcW9ca6UfbR5UZhknWs4`,
	"btn": `HQnxi5rCwT0Mw7VJZaBn`,
	"alert": `muX61iFcxY9t68oCq6fm`
};
export default ___CSS_LOADER_EXPORT___;
